'use strict';

exports.__esModule = true;

var _withRouter = require('react-router/withRouter');

var _withRouter2 = _interopRequireDefault(_withRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports


//////////////////
// WEBPACK FOOTER
// ./~/react-router-dom/withRouter.js
// module id = 544
// module chunks = 168707334958949